module.exports = __webpack_public_path__ + "images/icons_v2/volume-mute-filled-59fb2b1e.svg";